module.exports = __webpack_public_path__ + "img/interact-resukt_new.d2f644f3.png";